import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseClientBillsProps<T> = {
  filters: {
    search?: string
    page?: number
    clientId?: string
    branchId?: string
    status?: string
    startDate?: string
    endDate?: string
    showDescendants?: boolean
    kind?: string
  }
  mapper?: (data: any) => T
}

export const useClientBills = <T,>({
  filters: { search, page, clientId, branchId, status, startDate, endDate, showDescendants, kind },
  mapper = Mapper.default<T>(),
}: UseClientBillsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['companyBills', search, page, clientId, branchId, status, startDate, endDate, showDescendants, kind],
    queryFn: () => {
      return privateAxios.get(`/billing/bills/client_bills`, {
        params: {
          search,
          page,
          'q[company_id_eq]': clientId,
          'q[branch_id_eq]': branchId,
          'q[status_eq]': status,
          'q[opened_at_gteq]': startDate,
          'q[closed_at_lteq]': endDate,
          'q[show_from_descendants]': showDescendants,
          'q[company_kind_eq]': kind,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
